import { Toast } from 'vant'
import { R_P } from '@/api/activity'

function filterParams(data) {
  // 过滤参数
  if (!data) {
    return {}
  }
  let cloneData = {}
  Object.keys(data).forEach((key) => {
    if (typeof data[key] != 'function') {
      cloneData[key] = data[key]
    }
  })
  return cloneData
}
const state = {
  loginImagesList: null,
  exposureH5AllNameList: [],
  jobPresentationList: [],
  calendarJobPresentationList: null,
  jobList: null,
  showLoginFlag: false,
  total: 0,
  jobPresentationListPreCount: -1,
  jobPresentationListNextCount: -1,
  isFirstLoading: false,
  calendarDate: '',
  industryList: [],
  collectStatus: false,
}
const mutations = {
  /**
   * 为state项赋值
   * @param state
   * @param data
   */
  setStateItem(state, data) {
    state[data.key] = data.value
  },
}
const actions = {
  // 获取首页banner图列表
  async getLoginImagesList({ state, commit }, data) {
    try {
      const res = await R_P('getLoginImagesList', {
        ...filterParams(data),
      })
      if (res.data.code == 200) {
        commit('setStateItem', {
          key: 'loginImagesList',
          value: res.data.data,
        })
        data.cb ? data.cb() : ''
      } else {
        Toast(res.data.message)
      }
    } catch (e) {
      return false
    }
  },
  // 获取全部曝光位列表
  async getExposureAllList({ state, commit }, data) {
    try {
      const res = await R_P('getExposureAllList', {
        ...filterParams(data),
      })
      if (res.data.code == 200) {
        commit('setStateItem', {
          key: 'jobList',
          value: res.data.data.list,
        })
        commit('setStateItem', {
          key: 'total',
          value: res.data.data.count,
        })
        data.cb ? data.cb() : ''
      } else {
        Toast(res.data.message)
      }
    } catch (e) {
      return false
    } finally {
      commit('setStateItem', {
        key: 'isFirstLoading',
        value: false,
      })
    }
  },
  // 获取h5全部曝光位名称列表
  async getExposureH5AllList({ state, commit }, data) {
    try {
      const res = await R_P('getExposureH5AllList', {
        ...filterParams(data),
      })
      if (res.data.code == 200) {
        commit('setStateItem', {
          key: 'exposureH5AllNameList',
          value: res.data.data,
        })
        data.cb ? data.cb(res.data.data) : ''
      } else {
        Toast(res.data.message)
      }
    } catch (e) {
      return false
    }
  },
  // 职位宣讲会列表 日历
  async getCalendarJobPresentationList({ state, commit }, data) {
    try {
      const res = await R_P('getJobPresentationList', {
        ...filterParams(data),
      })
      if (res.data.code == 200) {
        commit('setStateItem', {
          key: 'calendarJobPresentationList',
          value: res.data.data.job_presentation_list,
        })
        data.cb ? data.cb(res.data.data) : ''
      } else {
        Toast(res.data.message)
      }
    } catch (e) {
      return false
    }
  },
  // 职位宣讲会列表
  async getJobPresentationListDefalut({ state, commit }, data) {
    try {
      const res = await R_P('getJobPresentationList', {
        ...filterParams(data),
      })
      if (res.data.code == 200) {
        commit('setStateItem', {
          key: 'jobPresentationList',
          value: res.data.data.job_presentation_list,
        })
        commit('setStateItem', {
          key: 'jobPresentationListNextCount',
          value: -1,
        })
        commit('setStateItem', {
          key: 'jobPresentationListPreCount',
          value: -1,
        })
        data.cb ? data.cb(res.data.data) : ''
      } else {
        Toast(res.data.message)
      }
    } catch (e) {
      return false
    }
  },
  async getJobPresentationList({ state, commit }, data) {
    try {
      const res = await R_P('getJobPresentationList', {
        ...filterParams(data),
      })
      if (res.data.code == 200) {
        commit('setStateItem', {
          key: 'jobPresentationList',
          value: res.data.data.job_presentation_list,
        })
        if (data.type == 1) {
          commit('setStateItem', {
            key: 'jobPresentationListNextCount',
            value: res.data.data.count,
          })
        } else if (data.type == 4) {
          commit('setStateItem', {
            key: 'jobPresentationListPreCount',
            value: res.data.data.count,
          })
        }
        data.cb ? data.cb(res.data.data) : ''
      } else {
        Toast(res.data.message)
      }
    } catch (e) {
      return false
    }
  },
  // 参加职位宣讲会
  async joinJobPresentation({ state, commit }, data) {
    try {
      const res = await R_P('joinJobPresentation', {
        ...filterParams(data),
      })
      if (res.data.code == 200) {
        data.cb ? data.cb() : ''
      } else {
        Toast(res.data.message)
      }
    } catch (e) {
      return false
    }
  },
  // 行业
  async queryIndustryInfo({ state, commit }, data) {
    try {
      const res = await R_P('queryIndustryInfo', {
        ...filterParams(data),
      })
      if (res && res.status === 200 && res.data.code === '200') {
        commit('setStateItem', {
          key: 'industryList',
          value: res.data.data,
        })
        data.cb && data.cb(res.data.data)
        return true
      } else {
        Toast(res.data.message, 'erro')
        return false
      }
    } catch (e) {
      console.log(e)
    }
  },
  // 提交采集
  async recruitmentInfoCollect({ state, commit }, data) {
    try {
      const res = await R_P('recruitmentInfoCollectUri', {
        ...filterParams(data),
      })
      if (res && res.status === 200 && res.data.code === '200') {
        commit('setStateItem', {
          key: 'collectStatus',
          value: true,
        })
        data.cb && data.cb(res.data.data)
        return true
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      console.log(e)
    }
  },
  // 提交采集验证码
  async recruitmentInfoSendCode({ state, commit }, data) {
    try {
      const res = await R_P('recruitmentInfoSendCodeUri', {
        ...filterParams(data),
      })
      if (res && res.status === 200 && res.data.code === '200') {
        // commit('setStateItem', {
        //     key: 'industryList',
        //     value: res.data.data,
        // })
        data.cb && data.cb()
        return true
      } else {
        Toast(res.data.message)
        return false
      }
    } catch (e) {
      console.log(e)
    }
  },
}

export default {
  state,
  actions,
  mutations,
  namespaced: true,
}
